import React, { memo, useCallback, useEffect, useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { useDispatch } from "react-redux";

import Icon from "../assets/icons/Icon";
import { Image } from "../Components";
import { uiActions } from "../store/ui/ui-slice";
import { FaArrowLeft } from "react-icons/fa";
import { useActiveSidebar, useManageRole } from "../Hooks";

const Sidebar = () => {
  const dispatch = useDispatch();
  const {
    isDashboard,
    isUpload,
    isPaymentGateway,
    isSport,
    isTournament,
    isMatch,
    isMarket,
    isFancy,
    isLine,
    isBookmaker,
    isImport,
    isOpenGame,
    isUser,
    isRole,
    isGameSetting,
    isUserSetting,
    isWhiteLabelSetting,
    isLiveTv,
    isCommentary,
  } = useManageRole();
  const { isGameTab, isReportTab, isRoleTab, isGlobalTab, isConfigTab } =
    useActiveSidebar();
  const [activeSections, setActiveSections] = useState({
    Games: false,
    reports: false,
    roleManagement: false,
    globalSettings: false,
    configuration: false,
  });

  useEffect(() => {
    // if (isGameTab) toggleSection("Games");
    // if (isReportTab) toggleSection("reports");
    // if (isRoleTab) toggleSection("roleManagement");
    // if (isGlobalTab) toggleSection("globalSettings");
    // if (isConfigTab) toggleSection("configuration");
  }, [isGameTab, isReportTab, isRoleTab, isGlobalTab, isConfigTab]);

  const toggleSection = useCallback((section) => {
    dispatch(uiActions.setHeading(section));
    setActiveSections((prev) => {
      const isCurrentlyActive = prev[section];

      const newSections = Object.keys(prev).reduce((acc, key) => {
        acc[key] = key === section ? !isCurrentlyActive : false;
        return acc;
      }, {});

      return newSections;
    });
  }, []);

  const handleSideCollapsed = () => {
    toggleSidebarSize(false);
  };

  const handleNavLinkClick = () => {
    toggleSidebarSize(true);
  };

  const toggleSidebarSize = useCallback((isTriggeredByNavLink = false) => {
    const body = document.querySelector("body");
    const isMobileView = window.innerWidth < 968;
    const currentSize = body.getAttribute("data-sidebar-size");

    if (isMobileView && isTriggeredByNavLink) {
      body.setAttribute(
        "data-sidebar-size",
        currentSize === "default" ? "collapsed" : "default"
      );
    }

    if (!isTriggeredByNavLink) {
      body.setAttribute(
        "data-sidebar-size",
        currentSize === "default" ? "collapsed" : "default"
      );
    }
  }, []);

  return (
    <>
      <aside className="startbar d-print-none">
        <div className="brand">
          <NavLink to="/" className="logo">
            <span className="">
              <Image
                src="/assets/images/dreamz247_logo.png"
                className="logo-lg logo-light"
              />
            </span>
          </NavLink>
          <span className="arrow_sidebar_icon" onClick={handleSideCollapsed}>
            <Icon name="FaArrowLeft" />
          </span>
        </div>
        <div className="startbar-menu">
          <div
            className="startbar-collapse"
            id="startbarCollapse"
            data-simplebar
          >
            <div className="d-flex align-items-start flex-column w-100">
              <ul className="navbar-nav mb-auto w-100">
                <li className="menu-label mt-2">
                  <span>Master</span>
                </li>

                <li className={`nav-item`}>
                  <NavLink
                    className={({ isActive }) =>
                      `nav-link ${isActive ? "active" : ""}`
                    }
                    to={{
                      pathname: "/",
                      state: { heading: "Dashboard" },
                    }}
                    onClick={() => {
                      handleNavLinkClick();
                      toggleSection("Dashboard");
                    }}
                  >
                    <Icon
                      name="MdDashboard"
                      className="iconoir-report-columns menu-icon"
                    />
                    <span>Dashboard</span>
                  </NavLink>
                </li>

                {isDashboard && (
                  <li className={`nav-item`}>
                    <NavLink
                      className={({ isActive }) =>
                        `nav-link ${isActive ? "active" : ""}`
                      }
                      to="/commentary/image-upload"
                      onClick={() => {
                        handleNavLinkClick();
                        toggleSection("Upload");
                      }}
                    >
                      <Icon
                        name="FaUpload"
                        className="iconoir-report-columns menu-icon"
                      />
                      <span>Upload</span>
                    </NavLink>
                  </li>
                )}

                {isDashboard && (
                  <li className={`nav-item`}>
                    <NavLink
                      className={({ isActive }) =>
                        `nav-link ${isActive ? "active" : ""}`
                      }
                      to="/commentary/payment-gateway"
                      onClick={() => {
                        handleNavLinkClick();
                        toggleSection("Payment Gateway");
                      }}
                    >
                      <Icon
                        name="MdOutlinePayments"
                        className="iconoir-report-columns menu-icon"
                      />
                      <span>Payment Gateway</span>
                    </NavLink>
                  </li>
                )}

                {(isSport ||
                  isTournament ||
                  isMatch ||
                  isMarket ||
                  isFancy ||
                  isLine ||
                  isBookmaker ||
                  isImport) && (
                  <li className="nav-item">
                    <Link
                      className={`nav-link arro_icon ${
                        activeSections.Games ? "active" : ""
                      }`}
                      onClick={(e) => {
                        e.preventDefault();
                        toggleSection("Games");
                      }}
                      aria-expanded={activeSections.Games}
                    >
                      <Icon
                        name="FaGamepad"
                        className="iconoir-task-list menu-icon"
                      />
                      <span>Games</span>
                    </Link>
                    <div
                      className={`collapse ${
                        activeSections.Games ? "show" : ""
                      }`}
                      id="sidebarTransactions"
                    >
                      <ul className="nav flex-column">
                        {isSport && (
                          <li className="nav-item">
                            <NavLink
                              className={({ isActive }) =>
                                `nav-link ${isActive ? "active" : ""}`
                              }
                              to={"/eventmaster/sport"}
                              onClick={handleNavLinkClick}
                            >
                              Sports
                            </NavLink>
                          </li>
                        )}
                        {isTournament && (
                          <li className="nav-item">
                            <NavLink
                              className={({ isActive }) =>
                                `nav-link ${isActive ? "active" : ""}`
                              }
                              to={"/eventmaster/tournaments"}
                              onClick={handleNavLinkClick}
                            >
                              Tournaments
                            </NavLink>
                          </li>
                        )}
                        {isMatch && (
                          <li className="nav-item">
                            <NavLink
                              className={({ isActive }) =>
                                `nav-link ${isActive ? "active" : ""}`
                              }
                              to={"/eventmaster/matches"}
                              onClick={handleNavLinkClick}
                            >
                              Matches
                            </NavLink>
                          </li>
                        )}
                        {isMarket && (
                          <li className="nav-item">
                            <NavLink
                              className={({ isActive }) =>
                                `nav-link ${isActive ? "active" : ""}`
                              }
                              to={"/eventmaster/market"}
                              onClick={handleNavLinkClick}
                            >
                              Markets
                            </NavLink>
                          </li>
                        )}
                        {isFancy && (
                          <li className="nav-item">
                            <NavLink
                              className={({ isActive }) =>
                                `nav-link ${isActive ? "active" : ""}`
                              }
                              to={"/eventmaster/fancy"}
                              onClick={handleNavLinkClick}
                            >
                              Fancy
                            </NavLink>
                          </li>
                        )}
                        {isLine && (
                          <li className="nav-item">
                            <NavLink
                              className={({ isActive }) =>
                                `nav-link ${isActive ? "active" : ""}`
                              }
                              to={"/eventmaster/line"}
                              onClick={handleNavLinkClick}
                            >
                              Line
                            </NavLink>
                          </li>
                        )}
                        {isBookmaker && (
                          <li className="nav-item">
                            <NavLink
                              className={({ isActive }) =>
                                `nav-link ${isActive ? "active" : ""}`
                              }
                              to={"/eventmaster/bookmaker"}
                              onClick={handleNavLinkClick}
                            >
                              Bookmaker
                            </NavLink>
                          </li>
                        )}
                        {isFancy && (
                          <>
                            <li className="nav-item">
                              <NavLink
                                className={({ isActive }) =>
                                  `nav-link ${isActive ? "active" : ""}`
                                }
                                to={"/eventmaster/ImportRadheFancy"}
                                onClick={handleNavLinkClick}
                              >
                                Import Radhe Fancy
                              </NavLink>
                            </li>
                            <li className="nav-item">
                              <NavLink
                                className={({ isActive }) =>
                                  `nav-link ${isActive ? "active" : ""}`
                                }
                                to={"/eventmaster/ImportIndiaFancy"}
                                onClick={handleNavLinkClick}
                              >
                                Import India Fancy
                              </NavLink>
                            </li>
                          </>
                        )}
                      </ul>
                    </div>
                  </li>
                )}

                {isOpenGame && (
                  <li className="nav-item">
                    <Link
                      className="nav-link"
                      onClick={(e) => {
                        e.preventDefault();
                        toggleSection("reports");
                      }}
                      aria-expanded={activeSections.reports}
                    >
                      <Icon
                        name="FaList"
                        className="iconoir-task-list menu-icon"
                      />

                      <span>Reports</span>
                    </Link>
                    <div
                      className={`collapse ${
                        activeSections.reports ? "show" : ""
                      }`}
                      id="sidebarTransactions"
                    >
                      <ul className="nav flex-column">
                        <li className="nav-item">
                          <NavLink
                            className={({ isActive }) =>
                              `nav-link ${isActive ? "active" : ""}`
                            }
                            onClick={handleNavLinkClick}
                            to={"/reports/openmarket"}
                          >
                            Open Market
                          </NavLink>
                        </li>
                        <li className="nav-item">
                          <NavLink
                            className={({ isActive }) =>
                              `nav-link ${isActive ? "active" : ""}`
                            }
                            onClick={handleNavLinkClick}
                            to={"/reports/settledmarket"}
                          >
                            Settle Market
                          </NavLink>
                        </li>
                        <li className="nav-item">
                          <NavLink
                            className={({ isActive }) =>
                              `nav-link ${isActive ? "active" : ""}`
                            }
                            onClick={handleNavLinkClick}
                            to={"/reports/cancelmarket"}
                          >
                            Cancel Market
                          </NavLink>
                        </li>
                        <li className="nav-item">
                          <NavLink
                            className={({ isActive }) =>
                              `nav-link ${isActive ? "active" : ""}`
                            }
                            onClick={handleNavLinkClick}
                            to={"/reports/casinomarket"}
                          >
                            Casino Market
                          </NavLink>
                        </li>
                      </ul>
                    </div>
                  </li>
                )}

                {(isRole || isUser) && (
                  <li className="nav-item">
                    <Link
                      className="nav-link"
                      onClick={(e) => {
                        e.preventDefault();
                        toggleSection("roleManagement");
                      }}
                      aria-expanded={activeSections.roleManagement}
                    >
                      <Icon
                        name="MdManageAccounts"
                        className="iconoir-task-list menu-icon"
                      />

                      <span>Role Management</span>
                    </Link>
                    <div
                      className={`collapse ${
                        activeSections.roleManagement ? "show" : ""
                      }`}
                      id="sidebarTransactions"
                    >
                      <ul className="nav flex-column">
                        {isUser && (
                          <li className="nav-item">
                            <NavLink
                              className={({ isActive }) =>
                                `nav-link ${isActive ? "active" : ""}`
                              }
                              onClick={handleNavLinkClick}
                              to={"/rolemanager/manageusers"}
                            >
                              Manage Users
                            </NavLink>
                          </li>
                        )}
                        {isRole && (
                          <>
                            <li className="nav-item">
                              <NavLink
                                className={({ isActive }) =>
                                  `nav-link ${isActive ? "active" : ""}`
                                }
                                onClick={handleNavLinkClick}
                                to={"/rolemanager/roles"}
                              >
                                Roles
                              </NavLink>
                            </li>
                            <li className="nav-item">
                              <NavLink
                                className={({ isActive }) =>
                                  `nav-link ${isActive ? "active" : ""}`
                                }
                                onClick={handleNavLinkClick}
                                to={"/rolemanager/moduleaccess"}
                              >
                                Module Access
                              </NavLink>
                            </li>
                          </>
                        )}
                      </ul>
                    </div>
                  </li>
                )}

                {(isGameSetting || isUserSetting || isWhiteLabelSetting) && (
                  <li className="nav-item">
                    <Link
                      className="nav-link"
                      onClick={(e) => {
                        e.preventDefault();
                        toggleSection("globalSettings");
                      }}
                      aria-expanded={activeSections.globalSettings}
                    >
                      <Icon
                        name="MdSettings"
                        className="iconoir-task-list menu-icon"
                      />

                      <span>Global Settings</span>
                    </Link>
                    <div
                      className={`collapse ${
                        activeSections.globalSettings ? "show" : ""
                      }`}
                      id="sidebarTransactions"
                    >
                      <ul className="nav flex-column">
                        {isGameSetting && (
                          <li className="nav-item">
                            <NavLink
                              className={({ isActive }) =>
                                `nav-link ${isActive ? "active" : ""}`
                              }
                              onClick={handleNavLinkClick}
                              to={"/globalsettings/gamesetting"}
                            >
                              Game Settings
                            </NavLink>
                          </li>
                        )}
                        {isUserSetting && (
                          <li className="nav-item">
                            <NavLink
                              className={({ isActive }) =>
                                `nav-link ${isActive ? "active" : ""}`
                              }
                              onClick={handleNavLinkClick}
                              to={"/globalsettings/usersetting"}
                            >
                              User Settings
                            </NavLink>
                          </li>
                        )}
                        {isWhiteLabelSetting && (
                          <li className="nav-item">
                            <NavLink
                              className={({ isActive }) =>
                                `nav-link ${isActive ? "active" : ""}`
                              }
                              onClick={handleNavLinkClick}
                              to={"/globalsettings/whitelabelsetting"}
                            >
                              WhiteLabel Settings
                            </NavLink>
                          </li>
                        )}
                      </ul>
                    </div>
                  </li>
                )}

                {(isImport ||
                  isLiveTv ||
                  isCommentary ||
                  isWhiteLabelSetting) && (
                  <li className="nav-item">
                    <Link
                      className="nav-link"
                      onClick={(e) => {
                        e.preventDefault();
                        toggleSection("configuration");
                      }}
                      aria-expanded={activeSections.configuration}
                    >
                      <Icon
                        name="MdSettingsSuggest"
                        className="iconoir-task-list menu-icon"
                      />

                      <span>Configuration</span>
                    </Link>
                    <div
                      className={`collapse ${
                        activeSections.configuration ? "show" : ""
                      }`}
                      id="sidebarTransactions"
                    >
                      <ul className="nav flex-column">
                        <li className="nav-item">
                          <NavLink
                            className={({ isActive }) =>
                              `nav-link ${isActive ? "active" : ""}`
                            }
                            onClick={handleNavLinkClick}
                            to={"/config/reactions"}
                          >
                            Reactions
                          </NavLink>
                        </li>
                        <li className="nav-item">
                          <NavLink
                            className={({ isActive }) =>
                              `nav-link ${isActive ? "active" : ""}`
                            }
                            onClick={handleNavLinkClick}
                            to={"/config/reopencancellist"}
                          >
                            Re-Open/Cancel List
                          </NavLink>
                        </li>
                        <li className="nav-item">
                          <NavLink
                            className={({ isActive }) =>
                              `nav-link ${isActive ? "active" : ""}`
                            }
                            onClick={handleNavLinkClick}
                            to={"/config/matchresult"}
                          >
                            Match Result
                          </NavLink>
                        </li>
                        {isLiveTv && (
                          <li className="nav-item">
                            <NavLink
                              className={({ isActive }) =>
                                `nav-link ${isActive ? "active" : ""}`
                              }
                              onClick={handleNavLinkClick}
                              to={"/config/livetv"}
                            >
                              Live TV
                            </NavLink>
                          </li>
                        )}
                        {isImport && (
                          <>
                            <li className="nav-item">
                              <NavLink
                                className={({ isActive }) =>
                                  `nav-link ${isActive ? "active" : ""}`
                                }
                                onClick={handleNavLinkClick}
                                to={"/config/import"}
                              >
                                Import
                              </NavLink>
                            </li>
                            <li className="nav-item">
                              <NavLink
                                className={({ isActive }) =>
                                  `nav-link ${isActive ? "active" : ""}`
                                }
                                onClick={handleNavLinkClick}
                                to={"/config/importdream"}
                              >
                                Import Dream
                              </NavLink>
                            </li>
                          </>
                        )}
                        {isWhiteLabelSetting && (
                          <li className="nav-item">
                            <NavLink
                              className={({ isActive }) =>
                                `nav-link ${isActive ? "active" : ""}`
                              }
                              onClick={handleNavLinkClick}
                              to={"/config/apisettings"}
                            >
                              Api Settings
                            </NavLink>
                          </li>
                        )}
                        <li className="nav-item">
                          <NavLink
                            className={({ isActive }) =>
                              `nav-link ${isActive ? "active" : ""}`
                            }
                            onClick={handleNavLinkClick}
                            to={"/config/chipssettings"}
                          >
                            Chips Settings
                          </NavLink>
                        </li>
                        <li className="nav-item">
                          <NavLink
                            className={({ isActive }) =>
                              `nav-link ${isActive ? "active" : ""}`
                            }
                            onClick={handleNavLinkClick}
                            to={"/config/rulessettings"}
                          >
                            Rules Settings
                          </NavLink>
                        </li>
                        <li className="nav-item">
                          <NavLink
                            className={({ isActive }) =>
                              `nav-link ${isActive ? "active" : ""}`
                            }
                            onClick={handleNavLinkClick}
                            to={"/config/welcomemsg"}
                          >
                            Welcome Message
                          </NavLink>
                        </li>
                      </ul>
                    </div>
                  </li>
                )}
              </ul>
            </div>
          </div>
        </div>
      </aside>
      <div
        className="startbar-overlay d-print-none"
        onClick={handleSideCollapsed}
      ></div>
    </>
  );
};

export default memo(Sidebar);
